import React, { memo, Fragment } from 'react';
import T from 'prop-types';
import { FontIcon, SelectImagesGalery, Separator, Text, TouchableItem } from '../../../../ReusableComponents';
import { colors, rs } from '../../../../../styles';
import Title from './Title';
import { Box, TitleContainer } from './styles';
import { NavigationService } from '../../../../../services';
import screens from '../../../../../navigation/screens';
import strings from '../../../../../localization';
import { getCurrentTheme } from '../../../../../templates';

const ImagesSelector = ({ images, setImage, setWebImages, imagesWeb }) => {
  const onPressPhotoTips = () => {
    NavigationService.navigate(screens.PhotoTips);
  };

  const currentTheme = getCurrentTheme();

  return (
    <Fragment>
      <Box withoutPadding withoutTopPadding gray>
        <TitleContainer withoutMargin>
          <Title withPadding>{strings.common.select_images}</Title>

          <TouchableItem onPress={onPressPhotoTips} style={[rs.bigPaddingTop, rs.paddingBottom]}>
            <Text color={currentTheme.colors.secondary} xsmall>
              {strings.items.photo_tips}
            </Text>
          </TouchableItem>
        </TitleContainer>

        <SelectImagesGalery images={images} imagesWeb={imagesWeb} setImage={setImage} setWebImages={setWebImages} />
      </Box>
      <Separator/>
    </Fragment>
  );
};

ImagesSelector.propTypes = {
  images: T.array,
  setImage: T.func,
};

export default ImagesSelector;
